export default __webpack_public_path__ + "static/research-9f6fca9191d60d07a5972a3e585846e7.png";